module.exports = __webpack_public_path__ + "img/2.1_planning.0d5f8ff2.jpg";